import { render, staticRenderFns } from "./ApplyToAllShapes.vue?vue&type=template&id=355a900a"
import script from "./ApplyToAllShapes.vue?vue&type=script&lang=js"
export * from "./ApplyToAllShapes.vue?vue&type=script&lang=js"
import style0 from "./ApplyToAllShapes.vue?vue&type=style&index=0&id=355a900a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('355a900a')) {
      api.createRecord('355a900a', component.options)
    } else {
      api.reload('355a900a', component.options)
    }
    module.hot.accept("./ApplyToAllShapes.vue?vue&type=template&id=355a900a", function () {
      api.rerender('355a900a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/ApplyToAllShapes.vue"
export default component.exports